import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  backgroundActive,
  lightBlack,
  lightGrey,
  lightTeal,
} from '../../mainTheme';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography
        mb={1}
        sx={{
          color: lightGrey,
          fontWeight: 500,
          fontSize: '12px',
          lineHeight: '16px',
          letterSpacing: '2px',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '2px',
          }}
          color={lightBlack}
        >
          {currentStep}
        </Typography>
        /{totalSteps}
      </Typography>
      <Box display="flex" width="100%" gap={1}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <Box
            key={index}
            flex="1 0 0"
            height="4px"
            bgcolor={currentStep > index ? lightTeal : backgroundActive}
            borderRadius="2px"
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProgressBar;
